.table {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - 4px);
  border-collapse: collapse;
  opacity: 1;
}
.table svg {
  vertical-align: unset;
}
.table > thead {
  width: calc(100% - 8px);
  min-height: 50px;
}
.table > thead,
.table > tbody > tr {
  display: table;
  width: calc(100% - 3px);
  table-layout: fixed;
}
.table > tbody {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px dotted black;
  border-bottom: 1px dotted black;
}

.table > tbody > tr > td,
.table > tfoot > tr > td {
  text-align: left;
  font-weight: 400;
  padding-top: 0;
  padding-left: 4px;
  padding-right: 4px;
  white-space: nowrap;
  overflow: hidden;
}
.table > thead > tr > th:first-child,
.table > tbody > tr > td:first-child {
  width: 32px !important;
  text-align: center !important;
  padding: 0 !important;
}

.table > thead > tr > th,
.table > tbody > tr > td {
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 400;
  color: black;
  background-color: var(--st-main-background-color);
  text-align: left;
}

.search {
  display: flex;
  flex-direction: row;
  width: calc(100% + 8px);
  align-items: center;
}
.search > input {
  width: calc(100% - 24px);
  line-height: 1px;
  border-radius: 4px;
  border: 1px solid black;
  margin-left: 4px;
}

.close {
  color: black;
  background-color: white;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  margin-left: 2px;
  cursor: pointer;
  line-height: 16px;
}
.close:hover {
  background-color: black;
  color: white;
}

.boxHeader {
  opacity: 1;
  background-color: var(--st-main-background-color);
}

.scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.scroll::-webkit-scrollbar-track {
  border-radius: 100px;
}
.scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 100px;
}
.scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.9);
}
